(function () {
  'use strict';

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

  function uniqueId(base, used) {
    var id = base || 'section';
    var n = 0;
    while (used.has(id) || document.getElementById(id)) {
      n += 1;
      id = base + '-' + n;
    }
    used.add(id);
    return id;
  }

  function throttle(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function initNav(aside) {
    var section = aside.closest('[id^="shopify-section-"]');
    if (!section) return;

    var content = section.querySelector('.article-template__content');
    if (!content) return;

    var list = aside.querySelector('[data-article-heading-nav-list]');
    var panel = aside.querySelector('[data-article-heading-nav-panel]');
    var toggle = aside.querySelector('[data-article-heading-nav-toggle]');
    if (!list || !panel) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      aside.classList.add('article-heading-nav--empty');
      if (toggle) toggle.hidden = true;
      return;
    }

    aside.classList.remove('article-heading-nav--empty');
    if (toggle) toggle.hidden = false;

    var usedIds = new Set();
    var prefix = aside.getAttribute('data-id-prefix') || 'heading';

    headings.forEach(function (h2) {
      var title = h2.textContent.trim();
      if (!title) return;

      var slug = slugify(title);
      if (!slug) slug = 'heading';

      if (!h2.id) {
        h2.id = uniqueId(prefix + '-' + slug, usedIds);
      } else {
        usedIds.add(h2.id);
      }

      var li = document.createElement('li');
      li.className = 'article-heading-nav__item';
      var a = document.createElement('a');
      a.className = 'article-heading-nav__link';
      a.href = '#' + h2.id;
      a.textContent = title;
      a.addEventListener('click', function () {
        aside.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    var links = list.querySelectorAll('a.article-heading-nav__link');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = aside.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function setActive(hash) {
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === hash);
      });
    }

    function updateActiveFromScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      var band = scrollY + Math.min(160, window.innerHeight * 0.18);
      var current = null;
      headings.forEach(function (h) {
        var top = h.getBoundingClientRect().top + scrollY;
        if (top <= band + 1) current = h;
      });
      if (current && current.id) setActive('#' + current.id);
    }

    var onScroll = throttle(updateActiveFromScroll, 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    updateActiveFromScroll();

    window.addEventListener(
      'hashchange',
      function () {
        setActive(window.location.hash);
      },
      false
    );
    if (window.location.hash) setActive(window.location.hash);
  }

  function run() {
    document.querySelectorAll('[data-article-heading-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
